import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MessageSchema = withDefaults({
  type: 'message',
  fields: [
    {
      kind: 'attribute',
      name: 'content',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'sender',
    },
    {
      kind: 'attribute',
      name: 'personId',
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: 'messages',
      },
    },
    {
      kind: 'belongsTo',
      name: 'messageable',
      type: 'messageable',
      options: {
        async: false,
        polymorphic: true,
        inverse: 'messages',
      },
    },
    {
      kind: 'hasMany',
      name: 'messageReceipts',
      type: 'message-receipt',
      options: {
        async: false,
        inverse: 'message',
      },
    },
  ],
});

export default MessageSchema;
